<mat-card>
  <mat-card-header>
    <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
      <div class="left">
        <mat-card-title>{{ pageTitle }}</mat-card-title>
        <mat-card-subtitle>{{ pageSubtitle }}</mat-card-subtitle>
      </div>
      <div class="right gap-10 g-just-flex">
        <button mat-flat-button (click)="navigateToCreate()">
          <mat-icon>add</mat-icon>
          Add SuperAdmin
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="my-12">
    <mat-divider></mat-divider>

    <mat-tab-group (selectedIndexChange)="onTabChange($event)" class="my-15">
      <mat-tab label="Active">
        <ng-template matTabContent>
          <div class="tab-content">
            @if(isLoading) {
            <div class="g-just-flex flex-column align-items-center py-40">
              <mat-spinner diameter="40"></mat-spinner>
              <p class="mt-16">Loading users...</p>
            </div>
            } @else if(tableDataSource.data.length > 0) {
            <table mat-table matSort (matSortChange)="onSortChange($event)" [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">


              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element">
                  <div class="user-name">
                    <strong>{{ element.fullName }}</strong>
                  </div>
                </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
              </ng-container>

              <!-- Phone Column -->
              <ng-container matColumnDef="phoneNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                <td mat-cell *matCellDef="let element">{{ element.phoneNumber || 'N/A' }}</td>
              </ng-container>

              <!-- Last Login Column -->
              <ng-container matColumnDef="lastLogin">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
                <td mat-cell *matCellDef="let element">
                  @if(element.lastLoginAt) {
                  <span>{{ element.lastLoginAt | date: 'medium' }}</span>
                  } @else {
                  <span class="subtitle-text-color-2">Never</span>
                  }
                </td>
              </ng-container>

              <!-- Created Date Column -->
              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.createdAt | date: 'mediumDate' }}
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span class="status-badge" [ngClass]="element.status === 'Active' ? 'active' : 'inactive'">
                    {{ element.status }}
                  </span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                  <button mat-icon-button [matMenuTriggerFor]="activeMenu" matTooltip="Actions">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #activeMenu="matMenu">
                    <button mat-menu-item (click)="viewDetails(element)">
                      <mat-icon>visibility</mat-icon>
                      <span>View Details</span>
                    </button>
                    <button mat-menu-item (click)="resetPassword(element)">
                      <mat-icon>lock_reset</mat-icon>
                      <span>Reset Password</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="deactivateUser(element)">
                      <mat-icon>block</mat-icon>
                      <span>Deactivate</span>
                    </button>
                    <button mat-menu-item (click)="deleteUser(element)" class="delete-action">
                      <mat-icon>delete</mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
            </table>
            } @else {
            <app-empty-state
              icon="PEOPLE"
              title="No active SuperAdmin users found"
              subtitle="Create your first SuperAdmin user to get started">
            </app-empty-state>
            }
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab label="Deactivated">
        <ng-template matTabContent>
          <div class="tab-content">
            @if(isLoading) {
            <div class="g-just-flex flex-column align-items-center py-40">
              <mat-spinner diameter="40"></mat-spinner>
              <p class="mt-16">Loading users...</p>
            </div>
            } @else if(tableDataSource.data.length > 0) {
            <table mat-table matSort (matSortChange)="onSortChange($event)" [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element">
                  <div class="user-name">
                    <strong>{{ element.fullName }}</strong>
                  </div>
                </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
              </ng-container>

              <!-- Phone Column -->
              <ng-container matColumnDef="phoneNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                <td mat-cell *matCellDef="let element">{{ element.phoneNumber || 'N/A' }}</td>
              </ng-container>

              <!-- Last Login Column -->
              <ng-container matColumnDef="lastLogin">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
                <td mat-cell *matCellDef="let element">
                  @if(element.lastLoginAt) {
                  <span>{{ element.lastLoginAt | date: 'medium' }}</span>
                  } @else {
                  <span class="subtitle-text-color-2">Never</span>
                  }
                </td>
              </ng-container>

              <!-- Created Date Column -->
              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.createdAt | date: 'mediumDate' }}
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span class="status-badge inactive">
                    {{ element.status }}
                  </span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                  <button mat-icon-button [matMenuTriggerFor]="deactivatedMenu" matTooltip="Actions">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #deactivatedMenu="matMenu">
                    <button mat-menu-item (click)="viewDetails(element)">
                      <mat-icon>visibility</mat-icon>
                      <span>View Details</span>
                    </button>
                    <button mat-menu-item (click)="reactivateUser(element)">
                      <mat-icon>check_circle</mat-icon>
                      <span>Reactivate</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="deleteUser(element)" class="delete-action">
                      <mat-icon>delete</mat-icon>
                      <span>Delete Permanently</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
            </table>
            } @else {
            <app-empty-state
              icon="PEOPLE"
              title="No deactivated SuperAdmin users"
              subtitle="All SuperAdmin users are currently active">
            </app-empty-state>
            }
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
